// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"8126546f","596":"2c249736"}[chunkId] + ".chunk.js";
};